import React from "react";
const jobContext = React.createContext();
export default jobContext;